import type { StarShape } from '@/stores/ratingService';
import type { Logos } from '@/components/HydrusRating/SymbolPaths';

export type RatingStatus = 'true' | 'false' | 'null';

export const byApiName: Record<
  StarShape,
  Record<
    RatingStatus,
    {
      name: Logos;
      color: string;
    }
  >
> = {
  circle: {
    true: {
 name: 'circle_filled',
color: '#02FA9D',
},
    false: {
 name: 'circle_filled',
color: '#ff0000',
},
    null: {
 name: 'circle_unfilled',
color: '#a1a1a1',
},
  },
  square: {
    true: {
 name: 'square_filled',
color: '#fcff9c',
},
    false: {
 name: 'square_filled',
color: '#ff0000',
},
    null: {
 name: 'square_unfilled',
color: '#a1a1a1',
},
  },
  'fat star': {
    true: {
 name: 'star_filled',
color: '#fff200',
},
    false: {
 name: 'star_unfilled',
color: '#ff0000',
},
    null: {
 name: 'star_unfilled',
color: '#a1a1a1',
},
  },
  'pentagram star': {
    true: {
 name: 'star_filled',
color: '#fac002',
},
    false: {
 name: 'star_unfilled',
color: '#ff0000',
},
    null: {
 name: 'star_unfilled',
color: '#a1a1a1',
},
  },
  'six point star': {
    true: {
 name: 'six_point_star',
color: '#fff200',
},
    false: {
 name: 'six_point_star',
color: '#ff0000',
},
    null: {
 name: 'six_point_star',
color: '#a1a1a1',
},
  },
  'eight point star': {
    true: {
 name: 'eight_point_star',
color: '#fff200',
},
    false: {
 name: 'eight_point_star',
color: '#ff0000',
},
    null: {
 name: 'eight_point_star',
color: '#a1a1a1',
},
  },
  'x shape': {
    true: {
 name: 'x_shape',
color: '#02FA9D',
},
    false: {
 name: 'x_shape',
color: '#ff0000',
},
    null: {
 name: 'x_shape',
color: '#a1a1a1',
},
  },
  diamond: {
    true: {
 name: 'diamond',
color: '#02FA9D',
},
    false: {
 name: 'diamond',
color: '#ff0000',
},
    null: {
 name: 'diamond',
color: '#a1a1a1',
},
  },
  heart: {
    true: {
 name: 'heart',
color: '#ff4466',
},
    false: {
 name: 'heart',
color: '#ff0000',
},
    null: {
 name: 'heart',
color: '#a1a1a1',
},
  },
  svg: {
    true: {
 name: 'star_filled',
color: '#fff200',
},
    false: {
 name: 'star_unfilled',
color: '#ff0000',
},
    null: {
 name: 'star_unfilled',
color: '#a1a1a1',
},
  },
};
